import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArtRequest } from '../RequestForm';
import './StepStyles.css';
import './ConfirmationStep.css';

interface ConfirmationStepProps {
  formData: ArtRequest;
  onBackToHome: () => void;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  formData,
  onBackToHome
}) => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const siteUrl = window.location.origin;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(siteUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const timeline = [
    {
      icon: '✅',
      title: 'request received',
      description: 'we have your doodle request and it\'s in the queue.',
    },
    {
      icon: '✏️',
      title: 'drawing in progress',
      description: 'once it\'s your turn your doodle gets drawn.',
    },
    {
      icon: formData.deliveryMethod === 'email' ? '📧' : '📬',
      title: 'on its way',
      description: formData.deliveryMethod === 'email'
        ? 'your doodle will land in your inbox.'
        : 'your doodle will arrive in your mailbox.',
    },
  ];

  return (
    <div className="step-container">
      <div className="confirmation-content">
        <div className="confirmation-header">
          <div className="confirmation-icon">🎉</div>
          <h2 className="step-title confirmation-title">doodle request submitted!</h2>
          <p className="confirmation-subtitle">
            thanks, {formData.firstName}! the doodle process typically takes
            <strong> 1–2 weeks</strong>. we'll make it worth the wait.
          </p>
        </div>

        <div className="confirmation-summary">
          <h3>your request</h3>
          <div className="summary-details">
            <div className="summary-row">
              <span className="summary-label">name</span>
              <span className="summary-value">{formData.firstName} {formData.lastName}</span>
            </div>
            <div className="summary-row">
              <span className="summary-label">doodle</span>
              <span className="summary-value">{formData.artDescription}</span>
            </div>
            <div className="summary-row">
              <span className="summary-label">delivery</span>
              <span className="summary-value">
                {formData.deliveryMethod === 'email' ? `email (${formData.email})` : `mail (${formData.city}, ${formData.state})`}
              </span>
            </div>
          </div>
        </div>

        <div className="confirmation-timeline">
          <h3>what happens next</h3>
          <div className="timeline-steps">
            {timeline.map((step, i) => (
              <div key={i} className={`timeline-step ${i === 0 ? 'timeline-step-active' : ''}`}>
                <div className="timeline-icon">{step.icon}</div>
                <div className="timeline-info">
                  <div className="timeline-title">{step.title}</div>
                  <div className="timeline-desc">{step.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="confirmation-actions">
          <div className="confirmation-share">
            <p>know someone who'd want a free doodle?</p>
            <button className="share-button" onClick={handleCopyLink}>
              {copied ? 'link copied!' : 'copy link to share'}
            </button>
          </div>

          <div className="confirmation-buttons">
            <button className="btn-primary" onClick={() => navigate('/gallery')}>
              browse the gallery
            </button>
            <button className="btn-secondary" onClick={onBackToHome}>
              back to home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationStep;
